/**
 * Dialog Actions
 */

import {
  ATTACH_SUPPLIER_DIALOG,
  CATALOG_DIALOG,
  COMMENT_DIALOG,
  IMAGE_CROPPER_DIALOG,
  IMAGE_DIALOG,
  INFO_DIALOG,
  LOGIN_DIALOG,
  MAP_DIALOG,
  OPEN_DIALOG,
} from 'redux/types';

export const ConfirmationToggleDialog = (value) => (dispatch) => {
  dispatch({ type: OPEN_DIALOG, payload: value });
};
export const UserLoginToggleDialog = (value) => (dispatch) => {
  dispatch({ type: LOGIN_DIALOG, payload: value });
};
export const AttachSupplierToggleDialog = (value) => (dispatch) => {
  dispatch({ type: ATTACH_SUPPLIER_DIALOG, payload: value });
};
export const commentToggleDialog = (value) => (dispatch) => {
  dispatch({ type: COMMENT_DIALOG, payload: value });
};
export const CatalogToggleDialog = (value) => (dispatch) => {
  dispatch({ type: CATALOG_DIALOG, payload: value });
};
export const imageToggleDialog = (value) => (dispatch) => {
  dispatch({ type: IMAGE_DIALOG, payload: value });
};
export const MapToggleDialog = (value) => (dispatch) => {
  dispatch({ type: MAP_DIALOG, payload: value });
};
export const InfoToggleDialog = (value) => (dispatch) => {
  dispatch({ type: INFO_DIALOG, payload: value });
};
export const ImageCropperDialog = (value) => (dispatch) => {
  dispatch({ type: IMAGE_CROPPER_DIALOG, payload: value });
};
